import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const ButtonBar = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <Container className={className}>{children}</Container>
);

export default ButtonBar;
